import Image from 'next/image'
import Link from 'next/link'
import { Anchor, Tag } from 'src/360ui'
import { newsArticleRoute } from 'src/consts'
import { useAppIntl } from 'src/i18n'
import styles from './styles.module.scss'

const defaultMainImage = {
  url: '/assets/news-markets.jpg',
}

export const NewArticleElement = ({ newsArticle }) => {
  const intl = useAppIntl()

  if (!newsArticle) return null
  const { title, slug, publishedAt } = newsArticle.attributes
  const mainImage =
    newsArticle.attributes.mainImage?.data?.attributes || defaultMainImage

  return (
    <Link href={newsArticleRoute({ slug })} prefetch={false} passHref>
      <Anchor className={styles.article} variant='md'>
        <Image
          src={mainImage?.url}
          alt={mainImage?.alternativeText}
          className={styles.image}
          width={72}
          height={72}
          objectFit='cover'
        />
        <div className={styles.contentData}>
          <Tag className={styles.tag} size='small'>
            {intl.timeago(new Date(publishedAt))}
          </Tag>
          <h3 className={styles.title}>{title}</h3>
        </div>
      </Anchor>
    </Link>
  )
}
